var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.207,
    height: 62.207,
    viewBox: "0 0 62.207 62.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M31.1,0A31.47,31.47,0,0,1,53.1,9.11,30.553,30.553,0,0,1,62.207,31.1,31.1,31.1,0,1,1,31.1,0Z",
    transform: "translate(1198 15.754)",
    fill: "#deebfc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-1198 -15.754)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M30.8,0A30.8,30.8,0,1,1,0,30.8,30.8,30.8,0,0,1,30.8,0Z",
    transform: "translate(1198 16.36)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351",
    transform: "translate(1207.856 30.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M14.784,0H27.1c5.3,0,9.947,2.788,12.943,7.634a14.024,14.024,0,0,1,1.841,7.15v7.392A15.167,15.167,0,0,1,37.131,33.04,14.278,14.278,0,0,1,27.1,36.96H14.784A15.144,15.144,0,0,1,3.366,31.568,14.224,14.224,0,0,1,0,22.176V14.784a15.268,15.268,0,0,1,3.062-9.01A14.412,14.412,0,0,1,14.784,0Z",
    transform: "translate(0 22.446)",
    fill: "#fafbfc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(12.144 0.125)",
    fill: "#fafbfc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default-profile.185399ac1610ffde36233a004b95bb8b.svg";
export { ForwardRef as ReactComponent };